import { Role } from '@futrli-sdk/roles';
import {
  API_PATHS,
  getAxiosResponseData,
  interpolatePathParams,
  ROUTE_PARAMS,
  APIClients
} from '@futrli/shared-services';

/**
 * Fetches and returns a full list of roles
 *
 * @function
 * @name fetchRoles
 * @param {string} workspaceId - Workspace id.
 * @returns {Promise<Role[]>} - A full list of roles
 */
export const fetchRoles = async (workspaceId: string): Promise<Role[]> => {
  const path = interpolatePathParams(API_PATHS.ROLES, { [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId });
  const response = await APIClients.getAPIClient().makeRequest({
    payload: {
      request: {
        url: path
      }
    }
  });

  return getAxiosResponseData(response).data;
};
